import { Route, Routes } from "react-router-dom";
import Home from "./Dashboard/Home/Home";
import Dashboard from "./Dashboard/Dashboard";
import System from "./Dashboard/System/System";
import SystemPost from "./Dashboard/System/SystemPost";
import SystemReported from "./Dashboard/System/SystemReported";
import Performance from "./Dashboard/Performance/Performance";
import UserManage from "./Dashboard/UserManange/UserManage";
import UserPage from "./Dashboard/UserManange/UserPage";
import Balance from "./Dashboard/Balance/Balance";
import Login from "./Dashboard/Auth/Login";
import BalanceUser from "./Dashboard/Balance/BalanceUser";
import Notfication from "./Dashboard/Notfication/Notfication";
import RequireAuth from "./Dashboard/Auth/RequireAuth";
import RequireBack from "./Dashboard/Auth/RequireBack";
import Ads from "./Dashboard/Ads/Ads";
import SingleAds from "./Dashboard/SingleAds/SingleAds";
import NotFound from "./Dashboard/NotFound/NotFound";
import MarketDashboard from "./Dashboard/Market/MarketDashboard";
import StoreRequestDetail from "./Dashboard/Market/StoreRequestDetail";
import MarketOrderDetail from "./Dashboard/Market/MarketOrderDetail";
import RevenueUserDetail from "./Dashboard/Revenue/RevenueUserDetail";
import RevenueCategoryDetail from "./Dashboard/Revenue/RevenueCategoryDetail";
import Wallet from "./Dashboard/Wallet/Wallet";
import Gifts from "./Dashboard/Gifts/Gifts";
import AppVersions from "./Dashboard/AppVersions/AppVersions";
import Withdrawals from "./Dashboard/Withdrawals/Withdrawals";
import Kyc from "./Dashboard/Kyc/Kyc";
import Refunds from "./Dashboard/Refunds/Refunds";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { profile } from "./store/actions/ProfileSlice";
import { getToken } from "./session";
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  const dispatch = useDispatch();
    useEffect(() => {
    if (getToken()) {
      dispatch(profile());
    }
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  } , [])
  return (
    <div className="App">
      <Routes>
        <Route element={<RequireBack />}>
          <Route path="/" element={<Login />} />
        </Route>
        <Route element={<RequireAuth />}>
          <Route path="/dashboard" element={<Dashboard />}>
            <Route path="/dashboard/home" element={<Home />} />
            <Route
              path="/dashboard/content-management-system"
              element={<System />}
            />
            <Route path="/dashboard/performance" element={<Performance />} />
            <Route
              path="/dashboard/content-management-system/post-details"
              element={<SystemPost />}
            />
            <Route
              path="/dashboard/content-management-system/:id"
              element={<SystemReported />}
            />
            <Route path="/dashboard/user-management" element={<UserManage />} />
            <Route
              path="/dashboard/user-management/:id"
              element={<UserPage />}
            />
            <Route path="/dashboard/balance" element={<Balance />} />
            <Route path="/dashboard/balance/:id" element={<BalanceUser />} />
            <Route path="/dashboard/notfication/" element={<Notfication />} />
            <Route path="/dashboard/ads/" element={<Ads />} />
            <Route path="/dashboard/ads/:id" element={<SingleAds />} />
            <Route path="/dashboard/market" element={<MarketDashboard />} />
            <Route
              path="/dashboard/market/store-requests/:id"
              element={<StoreRequestDetail />}
            />
            <Route
              path="/dashboard/market/orders/:id"
              element={<MarketOrderDetail />}
            />
            <Route path="/dashboard/revenue/users/:id" element={<RevenueUserDetail />} />
            <Route path="/dashboard/revenue/categories/:id" element={<RevenueCategoryDetail />} />
            <Route path="/dashboard/wallet" element={<Wallet />} />
            <Route path="/dashboard/gifts" element={<Gifts />} />
            <Route path="/dashboard/app-versions" element={<AppVersions />} />
            <Route path="/dashboard/withdrawals" element={<Withdrawals />} />
            <Route path="/dashboard/kyc" element={<Kyc />} />
            <Route path="/dashboard/refunds" element={<Refunds />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
